/**
 * Created by Vladislav on 2026-06-17
 */

class MinSizeComponent extends BaseComponent {
    onCreate() {
        this.minWidth = PrefabBuilder.resolveSize(this.options.minWidth || 0);
        this.minHeight = PrefabBuilder.resolveSize(this.options.minHeight || 0);
    }

    onAttach() {
        this.node.setContentSize(cleverapps.UI.calculateContentSize(this.node));

        const deltaX = Math.max(0, this.minWidth - this.node.width);
        const deltaY = Math.max(0, this.minHeight - this.node.height);

        if (deltaX || deltaY) {
            this.node.setContentSize(this.node.width + deltaX, this.node.height + deltaY);
        }
    }
}

Prefab.registerComponent("MinSizeComponent", MinSizeComponent);
